export default __webpack_public_path__ + "static/media/goo.f30c44ae.mp4";